import { z } from "zod";

/**
 * Tenant-Sortiment — welche Artikel aus dem Global-Catalog der Tenant
 * tatsächlich führt, plus optionale Override-Felder.
 *
 * Liegt unter `.bidi-handel/tenants/<tenantId>/sortiment.json`. Ersetzt die
 * Insel-`kundenartikel.json` ab Sprint G1.
 *
 * Override-Felder bewusst SEHR sparsam:
 *  - `listenpreisOverride` — wenn der Tenant einen anderen EK-Preis fährt
 *    (lokale Sonderkondition vom Hersteller etc.)
 *  - `einheitOverride` — wenn der Tenant in anderen Einheiten verkauft
 *    (z.B. Catalog "Stück", Tenant "Karton 10er") — selten
 *  - `active` — Tenant kann einen Catalog-Artikel ausblenden ohne ihn aus dem
 *    Stamm zu löschen
 *
 * Alles andere (Bezeichnung, Suchbegriffe, Fachdaten) wird IMMER aus dem
 * Catalog gelesen. So vermeiden wir Datenduplizierung und die kennen wir
 * aus der Insel-Variante zu gut.
 */

export const TenantArtikelRefSchema = z.object({
  /** Foreign Key auf GlobalArtikel.id (ULID). */
  catalogArtikelId: z.string().min(1),
  listenpreisOverride: z.number().nonnegative().optional(),
  einheitOverride: z.string().optional(),
  /** Tenant-Override der Basiseinheit/des Inhalts pro VE (Schritt 2) — selten,
   *  z.B. wenn der Tenant ein anderes Gebinde fährt als der Catalog. */
  basiseinheitOverride: z.string().optional(),
  inhaltProVEOverride: z.number().positive().optional(),
  /** false = Artikel im Sortiment, aber für Match/Bepreisung unsichtbar.
   *  Nützlich für Saison-Artikel oder geplante Aufnahme. */
  active: z.boolean().default(true),
  bemerkung: z.string().optional(),
  /** ISO-8601 — wann der Artikel ins Sortiment aufgenommen wurde. */
  addedAt: z.string().optional(),
});
export type TenantArtikelRef = z.infer<typeof TenantArtikelRefSchema>;

export const TenantSortimentSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  artikel: z.array(TenantArtikelRefSchema).default([]),
});
export type TenantSortiment = z.infer<typeof TenantSortimentSchema>;
